import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
// Components Import (Path: ../extra2/...)
import Breadcrumb from '../../extra2/Breadcrumb';
import FilterHeader from '../../extra2/FilterHeader';
import TabNavigation from '../../extra2/TabNavigation';
import ControlBar from '../../extra2/ControlBar';
import CameraGrid from '../../extra2/CameraGrid';
import Pagination from '../../extra2/Pagination';
import VideoPlayer from '../../extra2/VideoPlayer';
import { Box, Container, Grid } from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import LiveCamForm from './LiveCamForm';
import TimeCamForm from './TimeCamForm';
import { isBase64Image } from "../../libs/Libs";
import './main.css'

import {
  COMPANY,
  PROJECT,
  PROJECTALL,
  TIMELAPSE,
  TIMELAPSEALL,
  LIVECAM,
  LIVECAMALL,
  BRANDALL,
  USER,
  PRESETALL,
} from "../../services/actions";
import ActionBar from '../extra/ActionBar';
import MoreInfo from '../extra/MoreInfo';

function Cameras() {
  const navigate = useNavigate();
  const location = useLocation();
  const { tab } = location.state || {};
  const [activeTab, setActiveTab] = useState(tab || "Timelapse cam");
  const [gridColumns, setGridColumns] = useState(6);
  const [viewMode, setViewMode] = useState('grid');
  const [selectedCamera, setSelectedCamera] = useState(null);
  const user = useSelector((state) => state?.loginState?.auth);
  const projectState = useSelector((state) => state?.projectState);
  const projectallState = useSelector((state) => state?.projectallState);
  const companyState = useSelector((state) => state?.companyState);
  const livecamState = useSelector((state) => state?.livecamState);
  const livecamallState = useSelector((state) => state?.livecamallState);
  const brandallState = useSelector((state) => state?.brandallState);
  const timelapseState = useSelector((state) => state?.timelapseState);
  const timelapseallState = useSelector((state) => state?.timelapseallState);
  const presetallState = useSelector((state) => state?.presetallState);
  const [page, setPage] = React.useState(1); // current page
  const [pageSize, setPageSize] = React.useState(9);
  const [cameras, setCameras] = React.useState([]);

  const [open, setOpen] = React.useState({ status: false });
  const [defV, setDefV] = React.useState({});
  const [maps, setMaps] = React.useState([]);
  const [cols, setCols] = React.useState(3);
  const [view, setView] = React.useState(1);
  const [selectedProject, setSelectedProject] = React.useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: `${COMPANY}_GET`, payload: 0 });
    dispatch({ type: `${BRANDALL}_GET`, payload: 0 });
    dispatch({ type: `${PROJECTALL}_GET`, payload: 0 });
  }, []);

  useEffect(() => {
    fetchData(page, activeTab);
  }, [page, activeTab]);

  useEffect(() => {
    if (activeTab === "Timelapse cam") {
      setCameras(timelapseallState?.data);
    }
  }, [timelapseallState?.data, activeTab]);

  useEffect(() => {
    if (activeTab === "Live cam") {
      setCameras(livecamallState?.data);
    }
  }, [livecamallState?.data, activeTab]);

  useEffect(() => {
    if (livecamState?.success) {
      fetchData(page, activeTab);
      setOpen(false);
    }
  }, [livecamState?.success]);

  useEffect(() => {
    if (timelapseState?.success) {
      fetchData(page, activeTab);
      setOpen(false);
    }
  }, [timelapseState?.success]);

  useEffect(() => {
    if (selectedCamera) {
      dispatch({ type: `${PRESETALL}_GET`, payload: selectedCamera.id });
    }
  }, [selectedCamera]);

  const fetchData = (page = 0, selectedTab = "Timelapse cam", selectedProject = null) => {
    console.log("selectedProject", selectedProject);
    let url = "";
    let filter_url = ""
    if (selectedProject) {
      filter_url = `&filter_by={"project_id":"${selectedProject}"}`;
    }
    if (selectedTab === "Timelapse cam") {
      url =
        page === 0
          ? `timelapse/${page}/` : `timelapse/?page=${page}&limit=${pageSize}${filter_url}`; // pass page number
      dispatch({ type: `${TIMELAPSEALL}_GET`, payload: url });
    }
    else if (selectedTab === "Live cam") {
      url =
        page === 0
          ? `livecam/${page}/` : `livecam/?page=${page}&limit=${pageSize}${filter_url}`; // pass page number
      dispatch({ type: `${LIVECAMALL}_GET`, payload: url });
    }
    else if (selectedTab === "AI cam") {
      url =
        page === 0
          ? `aicam/${page}/` : `aicam/?page=${page}&limit=${pageSize}${filter_url}`; // pass page number
      // dispatch({ type: `${BRANDALL}_GET`, payload: url });
      setCameras([])
    }
  };

  const handleCameraClick = (camera) => {
    // setSelectedCamera(camera);
    // if (viewMode !== 'grid') setViewMode('grid');
    let video_mode = activeTab === "Timelapse cam" ? false : true;
    if (camera?.camera_name && activeTab === "Timelapse cam") {
      navigate("/camera-preview/", {
        state: {
          camera: camera,
          cameras: timelapseallState?.data?.results,
          video_mode: false,
        },
      });
    }
    else if (camera?.camera_name && activeTab === "Live cam") {
      const isPtzActive = Boolean(
        camera?.ptz === true ||
        camera?.ptz === 1 ||
        camera?.ptz === "true" ||
        camera?.has_ptz === true
      );
      if (isPtzActive) {
        navigate("/ptz-control/", {
          state: {
            camera: camera,
            cameras: livecamallState?.data?.results,
            video_mode: true,
          },
        });
      } else {
        navigate("/camera-preview/", {
          state: {
            camera: camera,
            cameras: livecamallState?.data?.results,
            video_mode: true,
          },
        });
      }
    }
  };

  const handleClosePlayer = () => {
    setSelectedCamera(null);
  };

  const getColFilledData = (cols, defaultValue = []) => {
    const arr = (cameras?.results ?? defaultValue)
      .concat(Array(cols * cols).fill({}))
      .slice(0, cols * cols || 2);
    return arr;
  };
  //activeTab === "Live cam"
  if (open.status && open.is_video_cam) {
    return (
      <Box>
        <LiveCamForm
          companies={companyState?.data?.results}
          projects={projectState?.data?.results}
          brands={brandallState?.data?.results}
          defaultValues={defV}
          onSubmit={(data) => {
            let valid = {
              ptz: data?.ptz,
              allow_recording: data?.allow_recording,
              active: data?.active,
              network_timelapse: data?.network_timelapse,
            };

            Object.keys(data).map((key) => {
              if (!isBase64Image(data?.image)) {
                delete data["image"];
              }
              if (key === "scroll_text") {
                valid[key] = data[key] || "";
              } else if (key === "username") {
                valid[key] = data[key] || "";
              } else if (key === "password") {
                valid[key] = data[key] || "";
              }

              else if (data[key] != undefined && data[key] != "") {
                valid[key] = data[key];
              }
              // Trim spaces in coordinates field
              let value = data[key];
              if (key === "coordinates" && typeof value === "string") {
                value = value.replace(/\s+/g, ""); // removes all spaces
              }
              // Add only if value exists
              if (value !== undefined && value !== "") {
                valid[key] = value;
              }
              if (valid.network_timelapse) {
                if (
                  valid.auto_timelapse_schedule_in_days !== undefined &&
                  valid.auto_timelapse_schedule_in_days !== ""
                ) {
                  valid.auto_timelapse_schedule_in_days = Number(
                    valid.auto_timelapse_schedule_in_days
                  );
                } else {
                  // optional: if required by backend, you can set a default or leave it out
                  valid.auto_timelapse_schedule_in_days = 0;
                }
                if (
                  valid.image_upload_intervals !== undefined &&
                  valid.image_upload_intervals !== ""
                ) {
                  valid.image_upload_intervals = Number(
                    valid.image_upload_intervals
                  );
                } else {
                  // optional: if required by backend, you can set a default or leave it out
                  valid.image_upload_intervals = 0;
                }
              } else {
                valid.auto_timelapse_schedule_in_days = 0;
                valid.image_upload_intervals = 0;
              }
            });
            console.log("DATA_cordinatestrim", data);
            const ACTION = data.id ? `${LIVECAM}_PATCH` : `${LIVECAM}_POST`;
            dispatch({ type: ACTION, payload: valid });
          }}
          onChange={(action, value) => {
            if (value) {
              dispatch({
                type: `${PROJECT}_GET`,
                payload: `project/0/?filter_by={"company":"${value}"}`,
              });
            }
          }}
          back={() => {
            setOpen(false);
          }} />
      </Box>
    )
  }

  if (open.status && activeTab === "Timelapse cam") {
    return (
      <Box>
        <TimeCamForm
          companies={companyState?.data?.results}
          projects={projectState?.data?.results}
          defaultValues={defV}
          onSubmit={(data) => {
            console.log("DATA new", data);
            let valid = {};
            valid['active'] = false;
            valid['allow_recording'] = false;
            Object.keys(data).map((key) => {
              if (!isBase64Image(data.image)) {
                delete data["image"];
              }
              if (key === "scroll_text") {
                valid[key] = data[key] || "";
              } else if (data[key] != "") {
                valid[key] = data[key];
              }
            });
            const ACTION = data.id ? `${TIMELAPSE}_PATCH` : `${TIMELAPSE}_POST`;
            dispatch({ type: ACTION, payload: valid });
          }}
          onChange={(action, value) => {
            if (value) {
              dispatch({
                type: `${PROJECT}_GET`,
                payload: `project/0/?filter_by={"company":"${value}"}`,
              });
            }
          }}
          back={() => {
            setOpen((prev) => ({ ...prev, status: false }));
          }} />
      </Box>
    )
  }

  if (viewMode == "view_more") {
    return (
      <Container maxWidth={false}>
        <MoreInfo
          data={{ ...defV }}
          group={['', '', 'company_name', 'created_at',]}
          onClose={() => { setViewMode("grid") }} />
      </Container>
    )
  }

  const handleAction = (action, data) => {
    if (action === "edit") {
      setDefV(data);
      let is_video_cam = data.camera_type == "TIMELAPSE" ? false : true
      setOpen((prev) => ({ ...prev, status: true, is_video_cam }));
    }
    if (action === "delete") {

      if (activeTab === "Live cam") {
        dispatch({ type: `${LIVECAM}_DELETE`, payload: data.id });
      }
      if (activeTab === "Timelapse cam") {
        dispatch({ type: `${TIMELAPSE}_DELETE`, payload: data.id });
      }
      // fetchData(page, activeTab);
    }
    if (action === "view") {
      handleCameraClick(data);
    }
    if (action === "view_more") {
      setDefV(data);
      setViewMode("view_more");
    }
    if (action === "map") {
      setMaps([{
        latlng: data?.coordinates?.split(","),
        desc: data?.camera_name,
      }])
      setViewMode("map");
    }
  }

  return (
    <Container maxWidth={false} className="cameras">
      <Box sx={{ py: 1 }}>
        <Box display={'flex'} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
          <Box sx={{ flexGrow: 1, width: 1 }}>
            <Breadcrumb title="Cameras" subtitle={activeTab} />
          </Box>
          <Box sx={{ flexGrow: 1 }}>
            <FilterHeader projects={projectallState?.data?.results || []} onProjectChange={(id) => {
              setSelectedProject(id);
              if (id == 'Select project') id = null;

              setPage(1);
              fetchData(1, activeTab, id);
            }} />
          </Box>
        </Box>

        {/* Main White Box */}
        <div className={`bg-white p-5 rounded-xl shadow-[0px_4px_20px_0px_rgba(0,0,0,0.1)] border border-gray-100 flex flex-col ${selectedCamera ? 'h-[650px]' : 'min-h-[600px]'}`}>

          {/* --- Top Navigation Area (UPDATED WITH MUI BOX FOR FLEX) --- */}
          <Box sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
            borderBottom: '1px solid #96969694',
            mb: 2,
            pb: 1
          }}>

            {/* Left Side: Tabs */}
            <Box sx={{ flexGrow: 1 }}>
              <TabNavigation activeTab={activeTab} setActiveTab={(tab) => { setActiveTab(tab); setOpen(false); }} />
            </Box>

            {/* Right Side: Controls (Moved up) */}
            <Box sx={{ mt: { xs: 2, md: 0 } }}>
              <ActionBar
                hasPermission={user.permissions.includes("camera.add_camera")}
                btnLabel="ADD CAMERA"
                setOpen={(s) => {
                  setDefV({}); // Reset default values
                  let is_video_cam = activeTab === "Timelapse cam" ? false : true
                  setOpen((prev) => ({ ...prev, status: true, is_video_cam }));
                }}
                onBtnClick={(type, col) => {
                  setPage(1)
                  setPageSize(col * col);

                  if (type === "grid") {
                    setCols(col);
                    setViewMode("grid");
                  }
                  if (type === "location") {
                    let cords = (timelapseallState?.data?.results ?? []).map(
                      (data) => ({
                        latlng: data?.coordinates?.split(","),
                        desc: data?.camera_name,
                      })
                    );
                    cords = cords.filter((data) => data.latlng[0]?.length > 5);
                    setMaps(cords);
                    setCols(col);
                    setViewMode("map");
                  }
                  if (type === "tabular") {
                    setViewMode("list");
                  }
                }}
              />
            </Box>
          </Box>
          {/* --- End Top Navigation Area --- */}

          {/* MAIN CONTENT AREA */}
          {!selectedCamera ? (
            // ---- NORMAL GRID VIEW ----
            <div className="flex flex-col h-full">
              <div className="flex-1 overflow-y-auto">
                <CameraGrid
                  cols={cols}
                  images={getColFilledData(cols)}
                  viewMode={viewMode}
                  onCameraClick={handleCameraClick}
                  handleAction={handleAction}
                  markers={maps}
                />
              </div>
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <Pagination
                  count={Math.ceil(cameras?.count / pageSize)}
                  page={page}
                  onChange={(e, value) => { setPage(value) }}
                  color="primary"
                />
              </Box>
            </div>
          ) : (
            // ---- SPLIT VIEW (Player + Sidebar) ----
            <Grid container spacing={2}>
              <Grid item size={9}>
                <VideoPlayer camera={selectedCamera} onClose={handleClosePlayer} />
              </Grid>
              <Grid item xs={12} md={5} size={3}>
                {getColFilledData(2, [], (presetallState?.data?.results || []))?.map((preset) => (
                  <Box key={preset?.id}>
                    <Box
                      component="img"
                      src={preset.thumbnail}
                      alt={preset.title}
                      className="card-img"
                      sx={{ width: '100%', height: 'auto', objectFit: 'cover', transition: 'transform 0.5s', opacity: 0.9 }}
                    />
                  </Box>
                ))}
              </Grid>
            </Grid>
          )}
        </div>

      </Box>
    </Container>
  );
}

export default Cameras;